import { api } from "boot/axios";
import { LocalStorage } from "quasar";
import memoize from "memoizee";

let cacheIndicatorsAll = {};
let cachedBrokerDataD = null;
let cachedBrokerPromiseD = null;
let supportPromiseCache = {
  daily: {},
  hourly: {},
  weekly: {},
};
let resistancePromiseCache = {
  daily: {},
  hourly: {},
  weekly: {},
};
let performancePromise = {
  intraStock: null,
  intraIndex: null,
  stock: null,
  index: null,
};
let buySellPromise = {
  cSymbol: {},
  timestamps: {},
};

export default () => {
  // MACD Cross
  const macdCross = async (date) => {
    try {
      const data = await api.get(`/data/macd-cross/?date=${date}`);
      return data;
    } catch (error) {
      throw error;
    }
  };
  // Live Dow Signals and Alerts
  const liveDow = async (date) => {
    try {
      const data = await api.get(`/data/live-dow/`, {
        params: {
          date: date,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };
  // Live Volume Spike
  const liveVolumeSpike = async () => {
    try {
      const data = await api.get(`/data/volume-spike/`);
      return data;
    } catch (error) {
      throw error;
    }
  };
  // BB Consolidating Breakouts
  const bbConsolidatingBreakouts = async () => {
    try {
      const data = await api.get(`/data/bb-consolidating-breakouts/`);
      return data;
    } catch (error) {
      throw error;
    }
  };
  // BB Consolidating
  const bbConsolidating = async () => {
    try {
      const data = await api.get(`/data/bb-consolidating/`);
      return data;
    } catch (error) {
      throw error;
    }
  };
  // Accumulation
  const Accumulation = memoize(
    async (days, symbol) => {
      let data;
      try {
        if (symbol) {
          data = await api.get(
            `/data/accumulation/?days=${days}&symbol=${symbol}`
          );
        } else {
          data = await api.get(`/data/accumulation/?days=${days}`);
        }
        return data;
      } catch (error) {
        throw error;
      }
    },
    {
      maxAge: 60 * 1000,
      promise: true,
      normalizer: (args) => JSON.stringify(args),
    }
  );

  // Distribution
  const Distribution = memoize(
    async (days, symbol) => {
      let data;
      try {
        if (symbol) {
          data = await api.get(
            `/data/distribution/?days=${days}&symbol=${symbol}`
          );
        } else {
          data = await api.get(`/data/distribution/?days=${days}`);
        }
        return data;
      } catch (error) {
        throw error;
      }
    },
    {
      maxAge: 60 * 1000,
      promise: true,
      normalizer: (args) => JSON.stringify(args),
    }
  );

  // LiveHotStocks
  const LiveHotStocks = async () => {
    try {
      const data = await api.get(`/data/live-hot-stock/script/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // CircuitSetup
  const CircuitSetup = async () => {
    try {
      const data = await api.get(`/data/circuit-setup/`);
      return data;
    } catch (error) {
      throw error;
    }
  };
  // CircuitSetup
  const ProbableCircuitSetup = async () => {
    try {
      const data = await api.get(`/data/bulk-txn/circuit/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Circuit Setup History
  const CircuitSetupHistory = async (date) => {
    try {
      const data = await api.get(`/data/circuit-setup-history/?date=${date}`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Bulk Transaction
  const BulkTransaction = async () => {
    try {
      const data = await api.get(`/data/bulk-txn-individual/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Bulk Transaction With Market
  const BulkTransactionWithMarket = async () => {
    try {
      const data = await api.get(`/data/bulk-txn-market-diamond/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Bulk Transaction With Market
  const BulkTransactionWithMarketBuySell = async () => {
    try {
      const data = await api.get(`/data/bulk-txn-market-diamond-plus/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Bulk Transaction With Market With Date
  const BulkTransactionWithMarketBuySellWithDate = async (date) => {
    try {
      const data = await api.get(`/data/bulk-txn/?date=${date}`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Bulk Transaction With Market With From Date and To Date
  const BulkTransactionHistory = async (from_date, to_date) => {
    try {
      const data = await api.get(
        `/data/bulk-txn-history/?from_date=${from_date}&to_date=${to_date}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Bulk Transaction With Market With Date and symbol
  const BulkTransactionWithMarketBuySellWithDateAndSymbol = async (
    date,
    symbol
  ) => {
    try {
      const data = await api.get(
        `/data/bulk-txn/?date=${date}&symbol=${symbol}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Bulk Transaction With Days
  const BulkTransactionWithDays = async (days) => {
    try {
      const data = await api.get(`/data/bulk-txn-market-days/?days=${days}`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Player Favourite With Days
  const PlayersFavouriteWithDays = async (days) => {
    try {
      const data = await api.get(`/data/players-favourite-days/?days=${days}`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // PlayersChoice Datewise
  const PlayersChoice = async (date) => {
    try {
      const data = await api.get(`/data/players-choices/?date=${date}`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Player Favourite Date wise
  const PlayersFavouriteDateWise = async ({
    from_date = null,
    to_date = null,
    date = null,
  } = {}) => {
    try {
      if (date) {
        const data = await api.get(
          `/data/player-favourite-history/?date=${date}`
        );
        return data;
      } else if (from_date && to_date) {
        const data = await api.get(
          `/data/player-favourite-history/?from_date=${from_date}&to_date=${to_date}`
        );
        return data;
      }
    } catch (error) {
      throw error;
    }
  };

  // Market Cap
  const MarketCap = async () => {
    try {
      const data = await api.get(`/data/market-cap/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // ActiveScriptLive
  const ActiveScriptLive = async (minutes) => {
    try {
      const data = await api.get(
        `/data/active-script-live/?minutes=${minutes}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Indicators
  const indicators = async (symbol) => {
    try {
      const data = await api.get(`/data/indicators/?symbol=${symbol}`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Indicators ALl
  const indicatorsAll = async (date) => {
    if (cacheIndicatorsAll[date]) {
      return cacheIndicatorsAll[date];
    }
    try {
      const data = await api.get(`/data/indicators-all/?date=${date}`);
      cacheIndicatorsAll[date] = data;
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Alpha Beta
  const alphaBeta = async (symbol = null) => {
    try {
      if (symbol) {
        const data = await api.get(`/data/alpha-beta/?symbol=${symbol}`);
        return data;
      }
      const data = await api.get(`/data/alpha-beta/`);
      return data;
    } catch (error) {
      throw error;
    }
  };
  // CandleStick Pattern
  const candleStickPattern = async (days) => {
    try {
      const data = await api.get(`/data/candlestick-type/?days=${days}`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  //  CandleStick Pattern symbolewise
  const candleStickPatternSymbolwise = async (symbol) => {
    try {
      const data = await api.get(
        `/data/candlestick-patterns/?symbol=${symbol}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  // True CandleStick Pattern symbolewise
  const trueCandleStickPatternSymbolwise = async (symbol) => {
    try {
      const data = await api.get(
        `/data/true-candlestick-patterns/?symbol=${symbol}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  // True CandleStick All Pattern symbolewise
  const trueCandleStickAllPatternSymbolwise = async (symbol) => {
    try {
      const data = await api.get(
        `/data/true-candlestick-patterns-all/?symbol=${symbol}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  // CandleStick Scan Pro
  const candleStickScanPro = async (date) => {
    try {
      const data = await api.get(`/data/candlestick-pattern/data?date=${date}`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // CandleStick Scan Pro Weekly
  const candleStickScanProWeekly = async (range) => {
    try {
      const data = await api.get(
        `/data/candlestick-patterns/?type=weekly&range=${range}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };
  //True CandleStick Scan Pro Weekly
  const truecandleStickScanProWeekly = async (range) => {
    try {
      const data = await api.get(
        `/data/true-candlestick-patterns/?type=weekly&range=${range}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };
  //price Action Filter Weekly
  const priceActionFilterWeekly = async (range) => {
    try {
      const data = await api.get(
        `/data/price-action-signals/?type=weekly&range=${range}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  // CandleStick Scan Pro Daily
  const candleStickScanProDaily = async (date) => {
    try {
      const data = await api.get(
        `/data/candlestick-patterns/?date=${date}&type=daily`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };
  // True CandleStick Scan Pro Daily
  const truecandleStickScanProDaily = async (date) => {
    try {
      const data = await api.get(
        `/data/true-candlestick-patterns/?date=${date}&type=daily`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };
  // Price Action Filter Daily
  const priceActionFilterDaily = async (date) => {
    try {
      const data = await api.get(
        `/data/price-action-signals/?date=${date}&type=daily`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  // CandleStick Scan Pro Hourly
  const candleStickScanProHourly = async (date) => {
    try {
      const data = await api.get(
        `/data/candlestick-patterns/?type=intraday&date=${date}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  // True CandleStick Scan Pro Hourly
  const truecandleStickScanProHourly = async (date) => {
    try {
      const data = await api.get(
        `/data/true-candlestick-patterns/?type=intraday&date=${date}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };
  // Price Action Filter Hourly
  const priceActionFilterHourly = async (date) => {
    try {
      const data = await api.get(
        `/data/price-action-signals/?type=intraday&date=${date}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Price Action Alert Daily
  const priceActionAlertDaily = async (days) => {
    try {
      const data = await api.get(
        `/data/price-action-daily-alert/?days=${days}`
      );

      return data;
    } catch (error) {
      throw error;
    }
  };

  // Price Action Signal Daily
  const priceActionSignalDaily = async (days) => {
    try {
      const data = await api.get(`/data/price-action-alert/?days=${days}`);

      return data;
    } catch (error) {
      throw error;
    }
  };

  // Price Action Signal Sell Daily
  const priceActionAlertSellDaily = async (days) => {
    try {
      const data = await api.get(
        `/data/price-action-daily-alert/sell/?days=${days}`
      );

      return data;
    } catch (error) {
      throw error;
    }
  };

  // Price Action Signal Sell Daily
  const priceActionSignalSellDaily = async (days) => {
    try {
      const data = await api.get(`/data/price-action-alert/sell/?days=${days}`);

      return data;
    } catch (error) {
      throw error;
    }
  };

  // Price Action Alert Hourly
  const priceActionAlertHourly = async (days) => {
    try {
      const data = await api.get(
        `/data/price-action-alert-hourly/?days=${days}`
      );

      return data;
    } catch (error) {
      throw error;
    }
  };

  // Price Action Signal Hourly
  const priceActionAlertSellHourly = async (days) => {
    try {
      const data = await api.get(
        `/data/price-action-alert-hourly/sell/?days=${days}`
      );

      return data;
    } catch (error) {
      throw error;
    }
  };

  // Price Action Alert Weekly
  const priceActionAlertWeekly = async (days) => {
    try {
      const data = await api.get(
        `/data/price-action-weekly-alert/?days=${days}`
      );

      return data;
    } catch (error) {
      throw error;
    }
  };

  // Price Action Sell Alert Weekly
  const priceActionAlertSellWeekly = async (days) => {
    try {
      const data = await api.get(
        `/data/price-action-weekly-alert/sell/?days=${days}`
      );

      return data;
    } catch (error) {
      throw error;
    }
  };

  // Price Action Signal Hourly
  const priceActionSignalHourly = async (days) => {
    try {
      const data = await api.get(
        `/data/price-action-signal-hourly/?days=${days}`
      );

      return data;
    } catch (error) {
      throw error;
    }
  };

  // Price Action Signal Sell Hourly
  const priceActionSignalSellHourly = async (days) => {
    try {
      const data = await api.get(
        `/data/price-action-signal-hourly/sell/?days=${days}`
      );

      return data;
    } catch (error) {
      throw error;
    }
  };

  // Price Action Signal Weekly
  const priceActionSignalWeekly = async (days) => {
    try {
      const data = await api.get(
        `/data/price-action-weekly-signal/?days=${days}`
      );

      return data;
    } catch (error) {
      throw error;
    }
  };

  // Price Action Signal Sell Weekly
  const priceActionSignalSellWeekly = async (days) => {
    try {
      const data = await api.get(
        `/data/price-action-weekly-signal/sell/?days=${days}`
      );

      return data;
    } catch (error) {
      throw error;
    }
  };

  // Dow Signal Daily
  const DowSignalDaily = async (days) => {
    try {
      const data = await api.get(`/data/dow-signal-daily/?days=${days}`);

      return data;
    } catch (error) {
      throw error;
    }
  };

  // Dow Signal Sell Daily
  const DowSignalSellDaily = async (days) => {
    try {
      const data = await api.get(`/data/dow-signal-daily/sell/?days=${days}`);

      return data;
    } catch (error) {
      throw error;
    }
  };

  // Dow Signal Alert Daily
  const DowSignalAlertDaily = async (days) => {
    try {
      const data = await api.get(`/data/dow-alert-daily/?days=${days}`);

      return data;
    } catch (error) {
      throw error;
    }
  };

  // Dow Signal Alert Sell Daily
  const DowSignalAlertSellDaily = async (days) => {
    try {
      const data = await api.get(`/data/dow-alert-daily/sell/?days=${days}`);

      return data;
    } catch (error) {
      throw error;
    }
  };

  // Trending Stocks
  const getTrendingStocks = async (days) => {
    try {
      const data = await api.get(`/data/trending-stocks/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Volatile-Stock
  const volatileStock = async () => {
    try {
      const data = await api.get("/data/volatile-stocks/");
      return data;
    } catch (error) {
      throw error;
    }
  };

  //consolidating-stocks
  const consolidating = async () => {
    try {
      const data = await api.get("/data/consolidating-stocks/");
      return data;
    } catch (error) {
      throw error;
    }
  };
  //Breakout-stocks
  const breakOut = async () => {
    try {
      const data = await api.get("/data/breakout-stocks/");
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Trending-stocks
  const trendingStock = async () => {
    try {
      const data = await api.get("/data/trending-stocks/");
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Chukul Performance

  const overallChukulPerformance = async () => {
    try {
      const data = await api.get("/data/overall-chukul-performance/");
      return data;
    } catch (error) {
      throw error;
    }
  };

  const overallChukulPerformanceSector = async () => {
    try {
      const data = await api.get("/data/overall-chukul-performance-sector/");
      return data;
    } catch (error) {
      throw error;
    }
  };

  const earlyOverallChukulPerformance = async () => {
    try {
      const data = await api.get("/data/overall-chukul-performance-early/");
      return data;
    } catch (error) {
      throw error;
    }
  };

  const chukulPerformance = async () => {
    try {
      const data = await api.get("/data/chukul-performance/");
      return data;
    } catch (error) {
      throw error;
    }
  };

  const earlyChukulPerformance = async () => {
    try {
      const data = await api.get("data/chukul-performance-early/");
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Symbols
  const allSymbol = async () => {
    try {
      const data = await api.get("/data/symbol/");
      return data;
    } catch (error) {
      throw error;
    }
  };

  // HistoryDataNew
  // for ARRAY data response
  const historyDataSearchNew = async (
    symbol,
    from,
    to,
    adj = false,
    chukulten = false
  ) => {
    try {
      let days = 365 * 5;
      let as_of_live = LocalStorage.getItem("as_of_live");
      const dateObject = new Date(as_of_live);
      const timestamp = dateObject.getTime();
      let to = parseInt(timestamp / 1000).toFixed(0);
      let fromDate = LocalStorage.getItem("token")
        ? "1040166773"
        : (to - 86400 * days).toString();
      if (adj == null) adj = true;
      if (adj) {
        const data = await api.get(
          `/data/adjhistorydata/data/?symbol=${symbol}&from=${fromDate}&to=${to}`
        );
        return data;
      } else {
        const data = await api.get(
          `/data/historydata/data/?symbol=${symbol}&from=${fromDate}&to=${to}`
        );
        return data;
      }
    } catch (error) {
      throw error;
    }
  };

  const intraHistoryDataSearchLive = async (symbol) => {
    try {
      const data = await api.get(
        `/data/newintrahistorydata/next/?symbol=${symbol}`
      );
      return data;
    } catch {}
  };

  //History Data Search
  const historyDataSearch = async (symbol, from, to, adj = false) => {
    try {
      if (adj) {
        const data = await api.get("/data/adjhistorydata/", {
          params: {
            symbol: symbol,
            from: from,
            to: to,
          },
        });
        return data;
      }
      const data = await api.get("/data/historydata/", {
        params: {
          symbol: symbol,
          from: from,
          to: to,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const weeklyNepse = async () => {
    try {
      const data = await api.get(`/data/v2/weekly-nepse/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Stock Performance
  const stockPerformance = async () => {
    if (performancePromise.stock) {
      return performancePromise.stock;
    }
    try {
      performancePromise.stock = api.get(
        `/data/historydata/performance/?type=stock`
      );
      const data = await performancePromise.stock;
      performancePromise.stock = null;
      return data;
    } catch (error) {
      throw error;
    }
  };
  //Index Performance
  const indexPerformance = async () => {
    if (performancePromise.index) {
      return performancePromise.index;
    }
    try {
      performancePromise.index = api.get(
        `/data/historydata/performance/?type=index`
      );
      const data = await performancePromise.index;
      performancePromise.index = null;
      return data;
    } catch (error) {
      throw error;
    }
  };

  // IntraHistoryData New
  // for ARRAY data response
  const intraHistoryDataSearchNew = async (symbol) => {
    try {
      // let as_of_live = LocalStorage.getItem("as_of_live_unix");
      // let to = parseInt(as_of_live).toFixed(0);
      // let from = to - 86400 * 9 * 30;
      const data = await api.get(
        `/data/newintrahistorydata/data/?symbol=${symbol}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Intraday Data Search
  const intraHistoryDataSearch = async (symbol, from, to) => {
    try {
      const data = await api.get("/data/intrahistorydata/", {
        params: {
          symbol: symbol,
          from: from,
          to: to,
        },
      });

      return data;
    } catch (error) {
      throw error;
    }
  };

  //Stock Performance
  const intraStockPerformance = async () => {
    if (performancePromise.intraStock) {
      return performancePromise.intraStock;
    }
    try {
      performancePromise.intraStock = api.get(
        "/data/intrahistorydata/performance/?type=stock"
      );
      const data = await performancePromise.intraStock;
      performancePromise.intraStock = null;
      return data;
    } catch (error) {
      throw error;
    }
  };
  //Index Performance
  const intraIndexPerformance = async () => {
    if (performancePromise.intraIndex) {
      return performancePromise.intraIndex;
    }
    try {
      performancePromise.intraIndex = api.get(
        "/data/intrahistorydata/performance/?type=index"
      );
      const data = await performancePromise.intraIndex;
      performancePromise.intraIndex = null;
      return data;
    } catch (error) {
      throw error;
    }
  };
  const stockSummary = async () => {
    try {
      const data = await api.get("/data/v2/daily-stock/");
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Below 120 days Average
  const tradingBelow120DaysAverage = async () => {
    try {
      const data = await api.get("/data/historydata/trading-below-120avg/");
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Near 52 weeks high-low
  const tradingNear52Week = async () => {
    try {
      const data = await api.get("/data/historydata/trading-near-52-week/");
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Buy Sell
  const buySellPreview = async () => {
    try {
      const data = await api.get("/data/buy-sell-preview/");
      return data;
    } catch (error) {
      throw error;
    }
  };

  const buySellDaily = async () => {
    try {
      const data = await api.get("/data/buysell/?days=0");

      return data;
    } catch (error) {
      throw error;
    }
  };

  const buySellWeekly = async () => {
    try {
      const data = await api.get("/data/buysell/?days=90");

      return data;
    } catch (error) {
      throw error;
    }
  };

  const weeklyBuySell = async () => {
    try {
      const data = await api.get("/data/buysellweekly/?days=365");

      return data;
    } catch (error) {
      throw error;
    }
  };
  const buySellHourly = async () => {
    try {
      const data = await api.get("/data/buysellintraday/?days=365");

      return data;
    } catch (error) {
      throw error;
    }
  };

  const buySellEarlyMonthly = async () => {
    try {
      const data = await api.get("/data/buysellearly/?days=21");
      return data;
    } catch (error) {
      throw error;
    }
  };

  //High Low Search SymbolWise

  const highlowDataSearchSymbolWise = async (symbol) => {
    try {
      const data = await api.get(`/data/high-low-series/?symbol=${symbol}`);

      return data;
    } catch (error) {
      throw error;
    }
  };

  //High Low Hourly Search SymbolWise

  const highlowHourlyDataSearchSymbolWise = async (symbol) => {
    try {
      const data = await api.get(
        `/data/high-low-series/hourly/?symbol=${symbol}`
      );

      return data;
    } catch (error) {
      throw error;
    }
  };
  //High Low Weekly Search SymbolWise

  const highlowWeeklyDataSearchSymbolWise = async (symbol) => {
    try {
      const data = await api.get(
        `/data/high-low-series/weekly/?symbol=${symbol}`
      );

      return data;
    } catch (error) {
      throw error;
    }
  };

  //BuySell search

  const buySellSearch = async (symbol) => {
    const now = Date.now();
    const cacheTime = 5000;
    if (
      buySellPromise.cSymbol[symbol] &&
      now - buySellPromise.timestamps[symbol] < cacheTime
    ) {
      return buySellPromise.cSymbol[symbol];
    }

    try {
      buySellPromise.timestamps[symbol] = now;
      buySellPromise.cSymbol[symbol] = api.get(
        `/data/buysell/?symbol=${symbol}`
      );
      const data = await buySellPromise.cSymbol[symbol];
      return data;
    } catch (error) {
      buySellPromise.cSymbol[symbol] = null;
      throw error;
    }
  };

  //BuySell search weekly

  const buySellSearchWeekly = async (symbol) => {
    try {
      const data = await api.get(`/data/buysellweekly/?symbol=${symbol}`);

      return data;
    } catch (error) {
      throw error;
    }
  };

  //trailing Stop Loss Buy Sell

  const trailingStopLossBuySell = async (symbol) => {
    try {
      const data = await api.get(
        `/data/buysell/trailing-stop-loss/?symbol=${symbol}`
      );

      return data;
    } catch (error) {
      throw error;
    }
  };

  // buy sell early

  const buySellEarlyDaily = async () => {
    try {
      const data = await api.get("/data/buysellearly/?days=0");

      return data;
    } catch (error) {
      throw error;
    }
  };

  const buySellEarlyWeekly = async () => {
    try {
      const data = await api.get("/data/buysellearly/?days=7");

      return data;
    } catch (error) {
      throw error;
    }
  };

  const buySellEarlySearch = async (symbol) => {
    try {
      const data = await api.get(`/data/buysellearly/?symbol=${symbol}`);

      return data;
    } catch (error) {
      throw error;
    }
  };

  //trailing Stop Loss Buy Sell early

  const trailingStopLossBuySellEarly = async (symbol) => {
    try {
      const data = await api.get(
        `/data/buysellearly/trailing-stop-loss/?symbol=${symbol}`
      );

      return data;
    } catch (error) {
      throw error;
    }
  };

  //Support Data Search
  const supportDataSearch = async (symbol) => {
    if (supportPromiseCache.daily[symbol]) {
      return supportPromiseCache.daily[symbol];
    }
    try {
      supportPromiseCache.daily[symbol] = api.get(
        `/data/support/?symbol=${symbol}`
      );
      const data = await supportPromiseCache.daily[symbol];
      supportPromiseCache.daily[symbol] = undefined;

      return data;
    } catch (error) {
      throw error;
    }
  };

  //Support Data Search Hourly
  const supportDataSearchHourly = async (symbol) => {
    if (supportPromiseCache.hourly[symbol]) {
      return supportPromiseCache.hourly[symbol];
    }
    try {
      supportPromiseCache.hourly[symbol] = api.get(
        `/data/support/hourly/?symbol=${symbol}`
      );
      const data = await supportPromiseCache.hourly[symbol];
      supportPromiseCache.hourly[symbol] = undefined;
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Support Data Search Weekly
  const supportDataSearchWeekly = async (symbol) => {
    if (supportPromiseCache.weekly[symbol]) {
      return supportPromiseCache.weekly[symbol];
    }
    try {
      supportPromiseCache.weekly[symbol] = api.get(
        `/data/support/weekly/?symbol=${symbol}`
      );
      const data = await supportPromiseCache.weekly[symbol];
      supportPromiseCache.weekly[symbol] = undefined;
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Resistance Data Search
  const resistanceDataSearch = async (symbol) => {
    if (resistancePromiseCache.daily[symbol]) {
      return resistancePromiseCache.daily[symbol];
    }
    try {
      resistancePromiseCache.daily[symbol] = api.get(
        `/data/resistance/?symbol=${symbol}`
      );
      const data = await resistancePromiseCache.daily[symbol];
      resistancePromiseCache.daily[symbol] = undefined;

      return data;
    } catch (error) {
      throw error;
    }
  };

  //Resistance Data Search Hourly
  const resistanceDataSearchHourly = async (symbol) => {
    if (resistancePromiseCache.hourly[symbol]) {
      return resistancePromiseCache.hourly[symbol];
    }
    try {
      resistancePromiseCache.hourly[symbol] = api.get(
        `/data/resistance/hourly/?symbol=${symbol}`
      );
      const data = await resistancePromiseCache.hourly[symbol];
      resistancePromiseCache.hourly[symbol] = undefined;
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Resistance Data Search Weekly
  const resistanceDataSearchWeekly = async (symbol) => {
    if (resistancePromiseCache.weekly[symbol]) {
      return resistancePromiseCache.weekly[symbol];
    }
    try {
      resistancePromiseCache.weekly[symbol] = api.get(
        `/data/resistance/weekly/?symbol=${symbol}`
      );
      const data = await resistancePromiseCache.weekly[symbol];
      resistancePromiseCache.weekly[symbol] = undefined;
      return data;
    } catch (error) {
      throw error;
    }
  };

  // FloorSheet Data Search

  const floorsheetSearch = async (symbol, date) => {
    try {
      const data = await api.get("/data/floorsheet/", {
        params: {
          symbol: symbol,
          date: date,
        },
      });

      return data;
    } catch (error) {
      throw error;
    }
  };
  // Intraday FloorSheet Data Search

  const intradayFloorsheetSearch = async (symbol, date) => {
    try {
      const data = await api.get("/data/floorsheet/intradaysymbol/", {
        params: {
          symbol: symbol,
          date: date,
        },
      });

      return data;
    } catch (error) {
      throw error;
    }
  };
  // FloorSheet Data Search By Date

  const floorsheetSearchByDate = async (date) => {
    try {
      const data = await api.get(`/data/floorsheet/bydate/?date=${date}`, {});

      return data;
    } catch (error) {
      throw error;
    }
  };
  // Intraday FloorSheet Data Search By Date

  const intradayFloorsheetSearchByDate = async (date) => {
    try {
      const data = await api.get(
        `/data/floorsheet/intradaydate/?date=${date}`,
        {}
      );

      return data;
    } catch (error) {
      throw error;
    }
  };

  //Broker Top Buy/Sell Intraday

  //Top Buy Intraday
  const TopBuyIntraday = async ({
    date = null,
    from_timestamp = null,
    to_timestamp = null,
    symbol = null,
    is_sum = false,
  }) => {
    try {
      const data = await api.get("/data/top-buy-with-time/", {
        params: {
          date,
          from_timestamp,
          to_timestamp,
          symbol,
          is_sum,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Top Sell Intraday
  const TopSellIntraday = async ({
    date = null,
    from_timestamp = null,
    to_timestamp = null,
    symbol = null,
    is_sum = false,
  }) => {
    try {
      const data = await api.get("/data/top-sell-with-time/", {
        params: {
          date,
          from_timestamp,
          to_timestamp,
          symbol,
          is_sum,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Broker Summary
  const brokerSummary = async () => {
    try {
      const data = await api.get("/data/broker-summary/");
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Broker Analytics

  const brokerAnalytics = async (from_date, to_date) => {
    try {
      const data = await api.get("/data/broker-analytics/", {
        params: {
          from_date: from_date,
          to_date: to_date,
          all: true,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Broker favourite holding release
  const brokerFavouriteHoldRelease = async (from_date, to_date, action) => {
    try {
      const data = await api.get("/data/broker-favourite-hold-release/", {
        params: {
          from_date: from_date,
          to_date: to_date,
          action: action,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Broker Analytics Average Sum

  const brokerAnalyticsAvgSum = async (from_date, to_date) => {
    try {
      const data = await api.get("/data/broker-analytics/avgsum/", {
        params: {
          from_date: from_date,
          to_date: to_date,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Broker Analytics With Broker

  const brokerAnalyticsWithBroker = async (
    from_date,
    to_date,
    broker = null
  ) => {
    try {
      const data = await api.get("/data/broker-analytics/", {
        params: {
          from_date: from_date,
          to_date: to_date,
          broker: broker,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const brokerAnalyticsWithSymbol = async (
    from_date,
    to_date,
    symbol = null
  ) => {
    try {
      const data = await api.get("/data/broker-analytics/", {
        params: {
          from_date: from_date,
          to_date: to_date,
          symbol: symbol,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Top BuyersDayWise
  const buyerStockDayWise = async (days, symbol = null) => {
    try {
      const data = await api.get("/data/top-buy/", {
        params: {
          symbol: symbol,
          days: days,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };
  //Top BuyersDateWise
  const buyerStockDateWise = async (
    from_date,
    to_date,
    symbol = null,
    broker = null
  ) => {
    try {
      // /api/data/top-buy/?from_date=2022-01-01&to_date=2023-01-30
      // TESTING1
      const data = await api.get("/data/top-buy/", {
        params: {
          symbol: symbol,
          broker: broker,
          from_date: from_date,
          to_date: to_date,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Top Buyers Trend DateWise
  const buyerTrendDateWise = async (date) => {
    try {
      const data = await api.get(`/data/broker-trend/?date=${date}`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Top SellerDayWise
  const sellerStockDayWise = async (days, symbol = null) => {
    try {
      const data = await api.get("/data/top-sell/", {
        params: {
          symbol: symbol,
          days: days,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };
  //Top SellerDateWise
  const sellerStockDateWise = async (
    from_date,
    to_date,
    symbol = null,
    broker = null
  ) => {
    try {
      const data = await api.get("/data/top-sell/", {
        params: {
          symbol: symbol,
          broker: broker,
          from_date: from_date,
          to_date: to_date,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Net netHoldingDayWise
  const netHoldingDayWise = async (days, symbol = null) => {
    try {
      const data = await api.get("/data/top-net-holding/", {
        params: {
          symbol: symbol,
          days: days,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };
  //Net netHoldingDateWise
  const netHoldingDateWise = async (
    from_date,
    to_date,
    symbol = null,
    broker = null
  ) => {
    try {
      const data = await api.get("/data/top-net-holding/", {
        params: {
          symbol: symbol,
          broker: broker,
          from_date: from_date,
          to_date: to_date,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Net netReleasedDayWise
  const netReleasedDayWise = async (days, symbol = null) => {
    try {
      const data = await api.get("/data/top-net-release/", {
        params: {
          symbol: symbol,
          days: days,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };
  //Net netReleasedDateWise
  const netReleasedDateWise = async (
    from_date,
    to_date,
    symbol = null,
    broker = null
  ) => {
    try {
      const data = await api.get("/data/top-net-release/", {
        params: {
          symbol: symbol,
          broker: broker,
          from_date: from_date,
          to_date: to_date,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  // top broker top holding
  const brokerTopHolding = async (days) => {
    try {
      const data = await api.get(`/data/broker-top-holding/?days=${days}`);

      return data;
    } catch (error) {
      throw error;
    }
  };

  // top broker top released
  const brokerTopRelease = async (days) => {
    try {
      const data = await api.get(`/data/broker-top-released/?days=${days}`);

      return data;
    } catch (error) {
      throw error;
    }
  };

  // top holding by broker
  const BrokerTopHoldingDayWise = async (broker, days) => {
    try {
      const data = await api.get(
        `/data/broker-top-holding/${broker}/holding/?days=${days}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  // top released by broker

  const BrokerTopReleasedDayWise = async (broker, days) => {
    try {
      const data = await api.get(
        `/data/broker-top-released/${broker}/released/?days=${days}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  // top broker top holding and released top 10 brokers

  const brokerListHoldingTop10DayWise = async (days) => {
    try {
      const data = await api.get(
        `/data/broker-top-holding/top-10/?days=${days}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const brokerListReleasedTop10DayWise = async (days) => {
    try {
      const data = await api.get(
        `/data/broker-top-released/top-10/?days=${days}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const brokerList = async () => {
    if (cachedBrokerDataD) {
      return cachedBrokerDataD;
    }
    if (cachedBrokerPromiseD) {
      return cachedBrokerPromiseD;
    }
    try {
      cachedBrokerPromiseD = api.get("/broker/");
      const data = await cachedBrokerPromiseD;
      cachedBrokerPromiseD = null;
      cachedBrokerDataD = data;
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  const meanReversalSignal = async (days) => {
    try {
      const data = await api.get(`/data/mean-reversible-signal/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };
  const meanReversalAlert = async (days) => {
    try {
      const data = await api.get(`/data/mean-reversible-alert-daily/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };
  const meanReversalSignalSell = async (days) => {
    try {
      const data = await api.get(`/data/mean-reversible-signal/sell/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };
  const meanReversalAlertSell = async (days) => {
    try {
      const data = await api.get(`/data/mean-reversible-alert-daily/sell/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const momentumBreakoutAlert = async (days) => {
    try {
      const data = await api.get(`/data/v2/momentum-breakout-alert-daily/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const momentumBreakoutSignal = async (days) => {
    try {
      const data = await api.get(`/data/v2/momentum-breakout-signal-daily/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const momentumBreakoutSellAlert = async (days) => {
    try {
      const data = await api.get(
        `/data/v2/momentum-breakout-sell-alert-daily/`,
        {
          params: { days: days },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const momentumBreakoutSellSignal = async (days) => {
    try {
      const data = await api.get(
        `/data/v2/momentum-breakout-sell-signal-daily/`,
        {
          params: { days: days },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const rsiDivergenceHiddenAlertSell = async (days) => {
    try {
      const data = await api.get(
        `/data/v2/rsi-divergence-sell-alert-daily-hidden/`,
        {
          params: { days: days },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const macdDivergenceAlert = async (days) => {
    try {
      const data = await api.get(`/data/v2/macd-divergence-alert-daily/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };
  const macdDivergenceSellAlert = async (days) => {
    try {
      const data = await api.get(`/data/v2/macd-divergence-alert-daily/sell/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const macdDivergencePriceAction = async (days) => {
    try {
      const data = await api.get(
        `/data/v2/macd-divergence-alert-daily-with-price-action/`,
        {
          params: { days: days },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };
  const macdDivergenceSellPriceAction = async (days) => {
    try {
      const data = await api.get(
        `/data/v2/macd-divergence-alert-daily-with-price-action/sell/`,
        {
          params: { days: days },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };
  const macdDivergencePriceActionSignal = async (days) => {
    try {
      const data = await api.get(
        `/data/v2/macd-divergence-alert-daily-with-price-action-signal/`,
        {
          params: { days: days },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };
  const macdDivergenceSellPriceActionSignal = async (days) => {
    try {
      const data = await api.get(
        `/data/v2/macd-divergence-alert-daily-with-price-action-signal/sell/`,
        {
          params: { days: days },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };
  const macdDivergenceAlertHidden = async (days) => {
    try {
      const data = await api.get(
        `/data/v2/macd-divergence-alert-daily-hidden/`,
        {
          params: { days: days },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };
  const macdDivergenceSellAlertHidden = async (days) => {
    try {
      const data = await api.get(
        `/data/v2/macd-divergence-alert-daily-hidden/sell/`,
        {
          params: { days: days },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };
  const macdDivergencePriceActionHidden = async (days) => {
    try {
      const data = await api.get(`/data/v2/macd-divergence-alert-daily-hidden/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };
  const macdDivergenceSellPriceActionHidden = async (days) => {
    try {
      const data = await api.get(`/data/v2/macd-divergence-alert-daily-hidden/sell/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };
  const macdDivergencePriceActionSignalHidden = async (days) => {
    try {
      const data = await api.get(`/data/v2/macd-divergence-price-action-signal-daily/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };
  const macdDivergenceSellPriceActionSignalHidden = async (days) => {
    try {
      const data = await api.get(`/data/v2/macd-divergence-price-action-signal-daily/sell/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const rsiDivergenceAlert = async (days) => {
    try {
      const data = await api.get(`/data/v2/rsi-divergence-alert-daily/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const rsiDivergenceAlertSell = async (days) => {
    try {
      const data = await api.get(`/data/v2/rsi-divergence-sell-alert-daily/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const rsiDivergenceAlertDailyWithPriceAction = async (days) => {
    try {
      const data = await api.get(
        `/data/v2/rsi-divergence-alert-daily-with-price-action/`,
        {
          params: { days: days },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const rsiDivergenceSellAlertDailyWithPriceAction = async (days) => {
    try {
      const data = await api.get(
        `/data/v2/rsi-divergence-alert-daily-with-price-action/sell/`,
        {
          params: { days: days },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const rsiDivergenceAlertDailyWithPriceActionSignal = async (days) => {
    try {
      const data = await api.get(
        `/data/v2/rsi-divergence-alert-daily-with-price-action-signal/`,
        {
          params: { days: days },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const rsiDivergenceSellAlertDailyWithPriceActionSignal = async (days) => {
    try {
      const data = await api.get(
        `/data/v2/rsi-divergence-alert-daily-with-price-action-signal/sell/`,
        {
          params: { days: days },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  // HIDDEN
  const rsiDivergenceHiddenAlert = async (days) => {
    try {
      const data = await api.get(
        `/data/v2/rsi-divergence-alert-daily-hidden/`,
        {
          params: { days: days },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const rsiDivergenceAlertDailyWithPriceActionHidden = async (days) => {
    try {
      const data = await api.get(
        `/data/v2/rsi-divergence-alert-daily-hidden-with-price-action/`,
        {
          params: { days: days },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const rsiDivergenceSellAlertDailyWithPriceActionHidden = async (days) => {
    try {
      const data = await api.get(
        `/data/v2/rsi-divergence-alert-daily-with-price-action/sell/`,
        {
          params: { days: days },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const rsiDivergenceAlertDailyWithPriceActionSignalHidden = async (days) => {
    try {
      const data = await api.get(
        `/data/v2/rsi-divergence-alert-daily-hidden-with-price-action-signal/`,
        {
          params: { days: days },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };
  const rsiDivergenceSellAlertDailyWithPriceActionSignalHidden = async (
    days
  ) => {
    try {
      const data = await api.get(
        `/data/v2/rsi-divergence-alert-daily-with-price-action-signal/sell/`,
        {
          params: { days: days },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const rsiDivergenceAlertHourly = async (days) => {
    try {
      const data = await api.get(`/data/v2/rsi-divergemce-alert-hourly/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const rsiDivergenceAlertHourlySell = async (days) => {
    try {
      const data = await api.get(`/data/v2/rsi-divergemce-alert-hourly/sell/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const rsiDivergenceSignal = async (days) => {
    try {
      const data = await api.get(`/data/v2/rsi-divergence-signal-daily/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const rsiDivergenceSignalSell = async (days) => {
    try {
      const data = await api.get(`/data/v2/rsi-divergence-sell-signal-daily/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const meanReversalSignalHourly = async (days) => {
    try {
      const data = await api.get(`/data/mean-reversible-signal-hourly/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const meanReversalSellSignalHourly = async (days) => {
    try {
      const data = await api.get(`/data/mean-reversible-signal-hourly/sell/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const meanReversalAlertHourly = async (days) => {
    try {
      const data = await api.get(`/data/mean-reversible-alert-hourly/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const meanReversalSellBoucketWeekly = async (days) => {
    try {
      const data = await api.get(`/data/mean-reversible-boucket-weekly/sell/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };
  const meanReversalBoucketWeekly = async (days) => {
    try {
      const data = await api.get(`/data/mean-reversible-boucket-weekly/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };
  const meanReversalSellBoucketHourly = async (days) => {
    try {
      const data = await api.get(`/data/mean-reversible-boucket-hourly/sell/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };
  const meanReversalBoucketHourly = async (days) => {
    try {
      const data = await api.get(`/data/mean-reversible-boucket-hourly/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const meanReversalAlertWeekly = async (days) => {
    // MEAN REVERSION ALERT WITH PRICE ACTION
    try {
      const data = await api.get(`/data/mean-reversible-alert-weekly/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const meanReversalSellAlertWeekly = async (days) => {
    // MEAN REVERSION SELL ALERT WITH PRICE ACTION
    try {
      const data = await api.get(`/data/mean-reversible-alert-weekly/sell/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const meanReversalSignalWeekly = async (days) => {
    try {
      const data = await api.get(`/data/mean-reversible-signal-weekly/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };
  const meanReversalSellSignalWeekly = async (days) => {
    try {
      const data = await api.get(`/data/mean-reversible-signal-weekly/sell/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const meanReversalSellAlertHourly = async (days) => {
    try {
      const data = await api.get(`/data/mean-reversible-alert-hourly/sell/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const bBmeanReversalAlert = async (days) => {
    try {
      const data = await api.get(`/data/bb-reversion-alert-daily/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };
  const bBmeanReversalSellAlert = async (days) => {
    try {
      const data = await api.get(`/data/bb-reversion-alert-daily/sell/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const bBmeanReversalSignal = async (days) => {
    try {
      const data = await api.get(`/data/bb-reversion-signal-daily/sell/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const bBmeanReversalSellSignal = async (days) => {
    try {
      const data = await api.get(`/data/bb-reversion-signal-daily/sell/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const meanReversionBuyList = async (days) => {
    try {
      const data = await api.get(`/data/mean-reversion-list-daily/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const meanReversionSellList = async (days) => {
    try {
      const data = await api.get(`/data/mean-reversion-list-daily/sell/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };
  const meanReversalBoucketDaily = async (days) => {
    try {
      const data = await api.get(`/data/mean-reversible-boucket-daily/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const meanReversalSellBoucketDaily = async (days) => {
    try {
      const data = await api.get(`/data/mean-reversible-boucket-daily/sell/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const BBBuyList = async (days) => {
    try {
      const data = await api.get(`/data/bb-list-daily/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const BBSellList = async (days) => {
    try {
      const data = await api.get(`/data/bb-list-daily/sell/`, {
        params: { days: days },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Strong Buy
  const StrongBuy = async () => {
    try {
      const data = await api.get(`/data/strong-buy/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  const StrongBuyTotal = async () => {
    try {
      const data = await api.get(`/data/strong-buy-total/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  const marketDepthStrongBuy = async () => {
    try {
      const data = await api.get("/data/market-depth-strong-buy/");
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Strong Sell
  const StrongSell = async () => {
    try {
      const data = await api.get(`/data/strong-sell/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  const StrongSellTotal = async () => {
    try {
      const data = await api.get(`/data/strong-sell-total/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  const marketDepthStrongSell = async () => {
    try {
      const data = await api.get("/data/market-depth-strong-sell/");
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Net Holding Data Search By Date and Symbol

  const NetHoldingByDateandSymbol = async (date, symbol) => {
    try {
      const data = await api.get(
        `/data/net-holding/?date=${date}&symbol=${symbol}`,
        {}
      );

      return data;
    } catch (error) {
      throw error;
    }
  };

  const filterTrend = async (payload) => {
    try {
      const data = await api.get("/data/trend-filter/", {
        params: payload,
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const getTechnicalData = async (date) => {
    try {
      const data = await api.get("data/technical-data/", {
        params: { date: date },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const getMarketSummaryBySymbol = async (symbol) => {
    try {
      const data = await api.get("data/v2/market-summary/bysymbol/", {
        params: { symbol: symbol },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const dailyNepse = async (symbol) => {
    try {
      const data = await api.get(`data/v2/daily/${symbol.toLowerCase()}/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    macdCross,
    liveVolumeSpike,
    liveDow,
    bbConsolidating,
    bbConsolidatingBreakouts,
    getTechnicalData,
    meanReversalBoucketHourly,
    meanReversalSellBoucketHourly,
    meanReversalBoucketWeekly,
    meanReversalSellBoucketWeekly,
    StrongBuy,
    StrongBuyTotal,
    marketDepthStrongBuy,
    StrongSell,
    StrongSellTotal,
    marketDepthStrongSell,
    meanReversionBuyList,
    meanReversionSellList,
    meanReversalSellBoucketDaily,
    meanReversalBoucketDaily,
    BBBuyList,
    BBSellList,
    bBmeanReversalAlert,
    bBmeanReversalSellAlert,
    bBmeanReversalSignal,
    bBmeanReversalSellSignal,
    macdDivergenceAlert,
    macdDivergenceSellAlert,
    macdDivergencePriceAction,
    macdDivergenceSellPriceAction,
    macdDivergencePriceActionSignal,
    macdDivergenceSellPriceActionSignal,
    macdDivergenceAlertHidden,
    macdDivergenceSellAlertHidden,
    macdDivergencePriceActionHidden,
    macdDivergenceSellPriceActionHidden,
    macdDivergencePriceActionSignalHidden,
    macdDivergenceSellPriceActionSignalHidden,
    rsiDivergenceSellAlertDailyWithPriceActionSignalHidden,
    rsiDivergenceAlertDailyWithPriceActionSignalHidden,
    rsiDivergenceSellAlertDailyWithPriceActionHidden,
    rsiDivergenceAlertDailyWithPriceActionHidden,
    rsiDivergenceAlertDailyWithPriceAction,
    rsiDivergenceSellAlertDailyWithPriceAction,
    rsiDivergenceAlertDailyWithPriceActionSignal,
    rsiDivergenceSellAlertDailyWithPriceActionSignal,
    meanReversalSellSignalHourly,
    meanReversalSignalHourly,

    meanReversalAlertWeekly,
    meanReversalSellAlertWeekly,
    meanReversalSellSignalWeekly,
    meanReversalSignalWeekly,

    momentumBreakoutAlert,
    momentumBreakoutSignal,
    momentumBreakoutSellAlert,
    momentumBreakoutSellSignal,
    rsiDivergenceHiddenAlert,
    rsiDivergenceHiddenAlertSell,
    rsiDivergenceAlert,
    rsiDivergenceAlertSell,
    rsiDivergenceAlertHourly,
    rsiDivergenceAlertHourlySell,
    rsiDivergenceSignal,
    rsiDivergenceSignalSell,
    meanReversalAlertHourly,
    meanReversalSellAlertHourly,
    meanReversalAlert,
    meanReversalSignal,
    meanReversalAlertSell,
    meanReversalSignalSell,
    brokerList,
    intraHistoryDataSearchLive,
    allSymbol,
    historyDataSearch,
    historyDataSearchNew,
    stockPerformance,
    indexPerformance,
    intraHistoryDataSearch,
    intraHistoryDataSearchNew,
    intraStockPerformance,
    intraIndexPerformance,

    tradingBelow120DaysAverage,
    tradingNear52Week,

    chukulPerformance,
    earlyChukulPerformance,
    overallChukulPerformance,
    overallChukulPerformanceSector,
    earlyOverallChukulPerformance,

    floorsheetSearch,
    floorsheetSearchByDate,
    intradayFloorsheetSearch,
    intradayFloorsheetSearchByDate,

    resistanceDataSearch,
    resistanceDataSearchHourly,
    resistanceDataSearchWeekly,

    supportDataSearch,
    supportDataSearchHourly,
    supportDataSearchWeekly,

    buySellPreview,

    buySellSearch,
    buySellSearchWeekly,

    buySellDaily,
    buySellWeekly,

    weeklyBuySell,
    buySellHourly,

    trailingStopLossBuySell,

    buySellEarlySearch,
    buySellEarlyDaily,
    buySellEarlyWeekly,
    buySellEarlyMonthly,
    trailingStopLossBuySellEarly,

    highlowDataSearchSymbolWise,
    highlowHourlyDataSearchSymbolWise,
    highlowWeeklyDataSearchSymbolWise,

    brokerSummary,

    brokerAnalytics,
    brokerFavouriteHoldRelease,

    brokerAnalyticsWithSymbol,
    brokerAnalyticsWithBroker,

    brokerAnalyticsAvgSum,

    buyerStockDayWise,
    sellerStockDayWise,
    netHoldingDayWise,
    netReleasedDayWise,

    buyerStockDateWise,
    sellerStockDateWise,
    netHoldingDateWise,
    netReleasedDateWise,

    brokerTopRelease,
    brokerTopHolding,

    BrokerTopHoldingDayWise,
    brokerListHoldingTop10DayWise,

    brokerListReleasedTop10DayWise,
    BrokerTopReleasedDayWise,

    volatileStock,
    trendingStock,
    consolidating,
    breakOut,
    getTrendingStocks,

    candleStickPattern,
    candleStickScanPro,

    candleStickPatternSymbolwise,
    trueCandleStickPatternSymbolwise,
    trueCandleStickAllPatternSymbolwise,

    candleStickScanProHourly,
    candleStickScanProDaily,
    candleStickScanProWeekly,

    truecandleStickScanProHourly,
    truecandleStickScanProDaily,
    truecandleStickScanProWeekly,

    priceActionFilterHourly,
    priceActionFilterDaily,
    priceActionFilterWeekly,

    alphaBeta,
    indicators,
    indicatorsAll,
    priceActionAlertDaily,
    priceActionSignalDaily,
    priceActionAlertSellDaily,
    priceActionSignalSellDaily,

    priceActionAlertHourly,
    priceActionSignalHourly,
    priceActionAlertSellHourly,
    priceActionSignalSellHourly,

    priceActionAlertWeekly,
    priceActionAlertSellWeekly,
    priceActionSignalWeekly,
    priceActionSignalSellWeekly,

    DowSignalDaily,
    DowSignalSellDaily,
    DowSignalAlertDaily,
    DowSignalAlertSellDaily,

    LiveHotStocks,
    CircuitSetup,
    ProbableCircuitSetup,
    CircuitSetupHistory,
    BulkTransaction,
    BulkTransactionWithMarket,
    BulkTransactionWithMarketBuySell,
    BulkTransactionHistory,
    BulkTransactionWithMarketBuySellWithDate,
    BulkTransactionWithMarketBuySellWithDateAndSymbol,
    BulkTransactionWithDays,
    PlayersFavouriteWithDays,
    PlayersChoice,
    PlayersFavouriteDateWise,
    MarketCap,

    ActiveScriptLive,
    Accumulation,
    Distribution,

    NetHoldingByDateandSymbol,
    buyerTrendDateWise,
    filterTrend,

    TopBuyIntraday,
    TopSellIntraday,
    weeklyNepse,
    getMarketSummaryBySymbol,
    dailyNepse,
    stockSummary,
  };
};
